/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Icon, Text, Theme, Tooltip, useTheme, VFlow } from 'bold-ui'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'

interface ConsultaSeguimentoPerguntasDiffListProps {
  listOfPerguntas: MChatPerguntaEnum[]
  listOfPerguntasObrigatorias: MChatPerguntaEnum[]
  listOfPerguntasExcluidas?: MChatPerguntaEnum[]
}

export function ConsultaSeguimentoPerguntasDiffList(props: Readonly<ConsultaSeguimentoPerguntasDiffListProps>) {
  const { listOfPerguntas, listOfPerguntasObrigatorias, listOfPerguntasExcluidas = [] } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const isRequired = (pergunta: MChatPerguntaEnum) => {
    return listOfPerguntasObrigatorias.includes(pergunta)
  }

  const isDeleting = (pergunta: MChatPerguntaEnum) => {
    return listOfPerguntasExcluidas.includes(pergunta)
  }

  return (
    <VFlow vSpacing={0} style={styles.list}>
      {listOfPerguntas.map((pergunta) => (
        <HFlow key={pergunta} style={styles.listItem} alignItems='center' justifyContent='space-between'>
          <Text key={pergunta}>
            Pergunta {getMChatPerguntaNumber(pergunta)}
            {isRequired(pergunta) && (
              <Text color='danger' fontWeight='bold'>
                {' '}
                *
              </Text>
            )}
          </Text>

          {isDeleting(pergunta) && (
            <Tooltip text='As respostas já registradas serão descartadas.'>
              <Icon icon='exclamationTriangleOutline' fill='alert' size={1} />
            </Tooltip>
          )}
        </HFlow>
      ))}
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  list: css`
    border: 1px solid ${theme.pallete.divider};
    & > div:not(:last-child) {
      border-bottom: 1px solid ${theme.pallete.divider};
    }
  `,
  listItem: css`
    padding: 0.5rem 1rem;
  `,
})
